import styled from 'styled-components';
import { Tag } from 'antd';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const GroupHeaderRow = styled.div`
  display: flex;
  align-items: flex-end; /* bottom-align children */
  gap: 16px;
  padding: 8px 0 0px;
  margin-bottom: 20px;

  .avatar-col {
    display: inline-flex;
    cursor: pointer;
    /* optional: constrain height for consistent baseline */
    align-items: center;
  }

  .name-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-self: flex-end; /* pin this column to the row bottom */
  }

  .group-name-input {
    background: transparent;
    color: #8fb4d3;
    padding: 6px 0;
    border: none !important;
    box-shadow: none !important;
    outline: none;
    border-bottom: 1px solid rgba(143, 180, 211, 0.8);
    border-radius: 0;
  }
  .group-name-input::placeholder {
    color: #8fb4d3;
    opacity: 0.95;
  }

  .kebab {
    color: #9aa5b1;
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const Chip = styled(Tag)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 4px 8px;
  border-radius: 999px;
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  .meta {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }
  .name {
    font-weight: 600;
  }
  .sub {
    color: #8c8c8c;
    font-size: 12px;
  }
`;
